 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/Cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTFRONT from '@/components/Text/Front'
 import TEXTTITLE from '@/components/Text/Title'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTCONTENTS from '@/components/Text/Contents'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTFOREWORD from '@/components/Text/Foreword'
 import TEXTPREFACE from '@/components/Text/Preface'
 import TEXTCHAPTER001 from '@/components/Text/Chapter001'
 import TEXTCHAPTER002 from '@/components/Text/Chapter002'
 import TEXTCHAPTER003 from '@/components/Text/Chapter003'
 import TEXTCHAPTER004 from '@/components/Text/Chapter004'
 import TEXTCHAPTER005 from '@/components/Text/Chapter005'
 import TEXTCHAPTER006 from '@/components/Text/Chapter006'
 import TEXTCHAPTER007 from '@/components/Text/Chapter007'
 import TEXTCHAPTER008 from '@/components/Text/Chapter008'
 import TEXTCHAPTER009 from '@/components/Text/Chapter009'
 import TEXTCHAPTER010 from '@/components/Text/Chapter010'
 import TEXTCHAPTER011 from '@/components/Text/Chapter011'
 import TEXTCHAPTER012 from '@/components/Text/Chapter012'
 import TEXTCHAPTER013 from '@/components/Text/Chapter013'
 import LOVE_2 from '@/components/love_2'
 import TEXTCONCLUSION from '@/components/Text/Conclusion'
 import TEXTAPPENDIX001 from '@/components/Text/Appendix001'
 import TEXTAPPENDIX002 from '@/components/Text/Appendix002'
 import TEXTAPPENDIX003 from '@/components/Text/Appendix003'
 import TEXTAPPENDIX004 from '@/components/Text/Appendix004'
 import TEXTAPPENDIX005 from '@/components/Text/Appendix005'
 import TEXTINDEX from '@/components/Text/Index'
 import TEXTABOUTTHEAUTHOR from '@/components/Text/Abouttheauthor'
 import TEXTBACKMATTER001 from '@/components/Text/Backmatter001'
 import TEXTBACKMATTER002 from '@/components/Text/Backmatter002'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/Contents",
 			"name" : "Text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/Acknowledgments",
 			"name" : "Text/Acknowledgments",
 			"component" : TEXTACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/Text/Foreword",
 			"name" : "Text/Foreword",
 			"component" : TEXTFOREWORD
 		},
 		{
 			"path" : "/Text/Preface",
 			"name" : "Text/Preface",
 			"component" : TEXTPREFACE
 		},
 		{
 			"path" : "/Text/Chapter001",
 			"name" : "Text/Chapter001",
 			"component" : TEXTCHAPTER001
 		},
 		{
 			"path" : "/Text/Chapter002",
 			"name" : "Text/Chapter002",
 			"component" : TEXTCHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js